<template>
  <div class="purchase-page">
    <my-header :title="title" />
    <div class="marlr-20">
      <!-- 图书card -->
      <div class="address" v-if="type == 12||info.is_entity == 1">
        <img class="add-img" src="@/assets/images/book/address.png" alt />
        <div class="add-info" v-if="address.is_default">
          <p class="add-userinfo">
            <span>{{address.user_name}}</span>
            <font>{{address.mobile}}</font>
          </p>
          <p
            class="add-province"
          >{{address.province_name+address.city_name+address.district_name+address.address}}</p>
        </div>
        <div class="add-choose" @click="chooseAddress" v-else>
          <img src="@/assets/images/book/pay-address.png" alt />
        </div>
        <i class="add-go" @click="chooseAddress" v-if="address.is_default"></i>
      </div>
      <div class="purchase-book" v-if="type == 12">
        <img class="cover" :src="info.cover_img" alt />
        <div>
          <div>
            <p class="bdi-title">{{info.title}}</p>
          </div>
          <div class="bdi-price">
            <p class="now-price">
              <icon-price size="middle" :priceType="this.type == 12 ? 2 : 1"></icon-price>
              <span>{{info.price | toFixPrice}}</span>
            </p>
            <p class="number">x{{num}}</p>
          </div>
        </div>
      </div>
      <!-- 课程card -->
      <div class="purchase-info" v-else>
        <div class="pi-title" :class="{'pi-title-bg': info.is_has_coupon}">
          <span>{{info.title}}</span>
          <font>{{info.price | toFixPrice}}</font>
        </div>
        <p
          v-if="$pub.showDuration(type)"
          class="pi-time"
        >{{info.start_play | fomartTime('MM月dd日 hh:mm')}}~{{info.end_play | fomartTime('MM月dd日 hh:mm')}}</p>
        <p class="pi-teacher">授课老师：{{info.teacher_name}}</p>
      </div>
      <!--  -->
      <div class="cell mar-lr20 mar-b20" v-if="type == 12">
        <p>购买数量</p>
        <van-stepper @change="computPrice" v-model="num" min="1" :max="info.stock" />
      </div>
      <van-cell
        title="优惠券"
        :is-link="coupons.length > 1 "
        :value="checked_coupon.coupon_id ? `满 ${checked_coupon.full_reduction/100} 减 ${checked_coupon.discounted_price/100}`: '无可用'"
        @click="showModel"
      />
      <div class="pi-price">
        <p>
          <span>商品金额</span>
          <font>
            <icon-price size="middle" :priceType="this.type == 12 ? 2 : 1"></icon-price>
            {{info.price | toFixPrice}}
          </font>
        </p>
        <p v-if="type == 12">
          <span>运费</span>
          <span>
            <icon-price size="middle" :priceType="this.type == 12 ? 2 : 1"></icon-price>
            {{info.ship_price | toFixPrice}}
          </span>
        </p>
        <p>
          <span>优惠券金额</span>
          <span>
            -
            <icon-price size="middle" :priceType="this.type == 12 ? 2 : 1"></icon-price>
            {{checked_coupon.discounted_price | toFixPrice}}
          </span>
        </p>
        <p>
          <span>合计</span>
          <span class="order-price">
            <icon-price size="middle" :priceType="this.type == 12 ? 2 : 1"></icon-price>
            {{order_price | toFixPrice}}
          </span>
        </p>
      </div>
    </div>
    <div class="price-btn">
      <van-button @click="onSubmit">提交订单</van-button>
      <p class="price">{{order_price | toFixPrice}}</p>
      <icon-price size="mini" :priceType="this.type == 12 ? 2 : 1"></icon-price>
      <p class="default">实付价格：</p>
    </div>
    <coupon ref="coupon" :couponList="coupons" comType="purchase" @userCoupon="userCoupon"></coupon>
    <van-dialog
      class="dialogs"
      v-model="exitShow"
      show-cancel-button
      confirm-button-text="添加"
      cancel-button-text="取消"
      @cancel="exitShow=false"
      @confirm="chooseAddress"
    >
      <p class="submit-p">您还没有添加地址，请添加地址</p>
    </van-dialog>
  </div>
</template>


<script>
import coupon from '@/components/Coupon'
import myHeader from '@/components/Header'
export default {
  name: 'Purchase',
  components: {
    coupon,
    myHeader
  },
  data() {
    return {
      title: {
        name: '确认订单'
      },
      id: this.$route.query.id,
      type: this.$route.query.type,
      info: {
        is_entity: 0
      },
      checked_coupon: {},
      coupons: [],
      order_price: 0,
      num: 1,
      address: {},
      exitShow: false
    }
  },
  methods: {
    computPrice() {
      if (this.info.checked_coupon.coupon_id) {
        // 使用优惠券
        this.userCoupon(this.checked_coupon.coupon_id)
      } else {
        // 未使用优惠券
        this.getShopInfo()
      }
    },
    getShopInfo() {
      this.$http
        .post(`/api/app/order/shopInfo`, {
          shop_id: this.id,
          type: this.type,
          product_number: this.num
        })
        .then(res => {
          this.info = res.info
          if (this.info.is_entity == 1) {
            let address_id = this.$store.state.pay_address_id
            this.$store.commit('SET_PAY_ADDRESS') //清除
            if (address_id) {
              this.$http.get(`/api/app/address/${address_id}`).then(res => {
                this.address = res
              })
            } else {
              this.getAddress()
            }
          }
          this.order_price = res.info.order_price
          this.checked_coupon = res.info.checked_coupon
          if (this.checked_coupon.coupon_id) this.getCouponList()
        })
    },
    getCouponList() {
      this.$http
        .post(`/api/app/userCouponWithGoods`, {
          shop_id: this.id,
          type: this.type
        })
        .then(res => {
          this.coupons = res
        })
    },
    userCoupon(id) {
      this.$http
        .post(`/api/app/order/selectCoupon`, {
          shop_id: this.id,
          coupon_id: id,
          product_number: this.num
        })
        .then(res => {
          this.order_price = res.order_price
          this.checked_coupon = res.checked_coupon
        })
    },
    showModel() {
      if (this.coupons.length > 1) {
        this.$refs.coupon.showModel()
      }
    },
    onSubmit() {
      if (this.type == 12 && !this.address.id) {
        this.exitShow = true
        return
      }
      this.$http
        .post(`/api/app/order/downOrder`, {
          shop_id: this.id,
          type: this.type,
          user_coupon_id: this.checked_coupon.coupon_id,
          address_id:
            this.type == 12 || this.info.is_entity == 1 ? this.address.id : '',
          product_number: this.num
        })
        .then(res => {
          if (res.is_zero_buy) {
            this.$pub.ToOrder(this.type)
          } else {
            this.$pub.toPay(
              {
                order_number: res.order_number,
                order_price: this.order_price,
                shop_id: this.id,
                type: this.type,
                order_id: res.id
              },
              'replace'
            )
          }
        })
    },
    async getAddress() {
      let address_list = await this.$http.get('/api/app/address')
      address_list.length &&
        address_list.forEach(item => {
          if (item.is_default == 1) {
            this.address = item
          }
        })
    },
    chooseAddress() {
      this.$router.push({
        name: 'Address',
        query: {
          payChoose: 1
        }
      })
    }
  },
  async created() {
    this.getShopInfo()
    if (this.type == 12) {
      let address_id = this.$store.state.pay_address_id
      this.$store.commit('SET_PAY_ADDRESS') //清除
      if (address_id) {
        this.address = await this.$http.get(`/api/app/address/${address_id}`)
      } else {
        this.getAddress()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.purchase-page {
  @extend %default-bg;
  background: #f0f2f5;
  .purchase-info {
    background: rgba(255, 255, 255, 1);
    border-radius: 8px;
    margin: 30px 0;
    padding: 30px;
    box-sizing: border-box;
    .pi-title {
      display: flex;
      justify-content: space-between;
      line-height: 60px;
      span {
        font-size: 28px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
      }
      font {
        font-size: 30px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(140, 140, 140, 1);
        width: 100px;
        flex: none;
      }
    }
    .pi-title-bg {
      padding-left: 50px;
      background: url('../../assets/theme-img/icon-coupon.png') no-repeat left
        center;
      background-size: 36px 28px;
    }
    .pi-time {
      font-size: 24px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 44px;
    }
    .pi-teacher {
      font-size: 24px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(183, 183, 183, 1);
      line-height: 44px;
    }
  }
  .mar-b20 {
    margin-bottom: 20px;
    border-radius: 20px;
  }
  .marlr-20 {
    margin: 0 20px;
  }
  .address {
    display: flex;
    align-items: center;
    background: #fff;
    margin-top: 20px;
    min-height: 138px;
    .add-img {
      width: 58px;
      height: 58px;
      margin-left: 30px;
      flex: none;
    }
    .add-info {
      flex: 1;
      margin-left: 20px;
      .add-userinfo {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        span {
          font-size: 28px;
          color: rgba(32, 36, 42, 1);
        }
        font {
          padding-left: 10px;
          font-size: 24px;
          color: rgba(140, 140, 140, 1);
        }
      }
      .add-province {
        padding-top: 6px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(32, 36, 42, 1);
        line-height: 30px;
      }
    }
    .add-choose {
      flex: 1;
      margin-left: 20px;
      img {
        margin-top: 10px;
        width: 218px;
        height: 42px;
      }
    }
    .add-go {
      flex: none;
      width: 60px;
      height: 168px;
      background: url('~@/assets/images/book/icon-go.png') no-repeat center
        center;
      background-size: 21px 36px;
    }
  }
  .purchase-book {
    background: #fff;
    display: flex;
    margin: 20px 0;
    padding: 30px;
    border-radius: 20px;
    .cover {
      width: 132px;
      height: 184px;
      flex: none;
    }
    > div {
      margin-left: 28px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      .bdi-title {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 48px;
      }
      .bdi-price {
        text-align: right;
        .now-price {
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(238, 31, 31, 1);
        }
        .number {
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
          line-height: 40px;
        }
      }
    }
  }
  .p-coupon {
    height: 96px;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    span {
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
    }
    font {
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(140, 140, 140, 1);
    }
    font.active {
      padding-right: 36px;
      background: url('../../assets/images/icon-go.png') no-repeat right center;
      background-size: 20px 30px;
    }
  }
  .pi-price {
    margin-top: 20px;
    background: #fff;
    padding: 30px;
    border-radius: 20px;
    p {
      font-size: 26px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(140, 140, 140, 1);
      line-height: 44px;
      display: flex;
      justify-content: space-between;
      .order-price {
        font-size: 30px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(224, 32, 32, 1);
      }
    }
  }
  .cell {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 96px;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    padding: 0 30px;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
  }
  .submit-p {
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    line-height: 48px;
    text-align: center;
    padding: 60px 90px;
  }
  .dialogs /deep/ .van-dialog__confirm.van-button {
    background: #fff;
    color: $theme_color;
  }
}
.price-btn {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 108px;
  background: #fff;
  /deep/ .price-ico {
    margin-bottom: 4px;
  }
  p.default {
    font-family: PingFangSC-Medium;
    color: #595959;
    font-size: 28px;
    padding: 10px 4px 0 48px;
  }
  p.price {
    color: #e02020;
    font-size: 28px;
    margin-left: 2px;
    margin-right: 24px;
    padding-top: 4px;
  }
  img {
    width: 20px;
    margin-top: 10px;
  }
  button {
    width: 226px;
    height: 74px;
    background: rgba(65, 105, 255, 1);
    border-radius: 37px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    font-size: 26px;
    text-align: center;
    line-height: 74px;
    background: $theme_color;
    border: 0;
    margin-right: 20px;
  }
}
</style>
